import React from 'react'

import { EDH_FORMATS } from 'types/deck'

import { SET_ACTIVE_STATE, TOGGLE_MODAL } from 'redux/active/actions/types'
import { useActionless, useAppSelector } from 'redux/hooks'
import { useRightPanel } from 'hooks/useRightPanel'

import { Button } from 'components/deckPage/header/BannerButton'

import styles from './rightPanelControls.module.scss'

type Props = {}

const RightPanelControls = ({}: Props) => {
  const deckId = useAppSelector(state => state.deck.id)
  const snapshotMeta = useAppSelector(state => state.deck.snapshotMeta)
  const format = useAppSelector(state => state.deck.format)

  const [setActiveState, toggleModal] = useActionless(SET_ACTIVE_STATE, TOGGLE_MODAL)
  const [rightPanelStatus, setRightPanelStatus] = useRightPanel()

  return (
    <div className={styles.container}>
      <Button icon="pie graph" label="Stats" onClick={() => setRightPanelStatus({ ...rightPanelStatus, open: true })} />
      <Button icon="cart" label="Buy" onClick={() => toggleModal({ modalName: 'bulkBuy', flag: true })} />

      {EDH_FORMATS.includes(format) && (
        <Button icon="edhrec" label="Recs" onClick={() => setActiveState({ searchOpen: 'recs' })} />
      )}

      {!!deckId && (
        <Button
          icon="exchange"
          label="Compare"
          to={`/partialCompare/?one=${!!snapshotMeta ? 's' : 'd'}_${deckId}&diffFields=totalQuantity`}
        />
      )}
    </div>
  )
}

export default RightPanelControls
